module.exports = __webpack_public_path__ + "images/category_lp/tablet_smartwatch/store_images/5@2x_60f66f8aa7328b77146b0f87bb8598c6.png";